export default __webpack_public_path__ + "static/media/hero-image4.e0155b72.jpg";